module.exports = __webpack_public_path__ + "img/Bars.b90ef5e1.jpg";